import { styled, Typography } from '@mui/material';

export const Title = styled(Typography)`
  text-align: center;
  font-size: 30px;
  line-height: 34px;
  font-weight: 700;

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 36px;
    line-height: 43px;
  }
`;

export const SubTitle = styled(Typography)`
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 30px;
    line-height: 34px;
  }
`;
